import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b209d94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_wrap" }
const _hoisted_2 = { class: "login" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "欢迎登录", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "wrap_from_top" }
const _hoisted_6 = { class: "form_item" }
const _hoisted_7 = { class: "wrap_from_bottom" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "form_input" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "form_bottom" }
const _hoisted_12 = { class: "wrap_form_btn" }
const _hoisted_13 = { class: "wrap_active" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#808080"} }, "忘记密码", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#808080"} }, "免费注册", -1))
const _hoisted_16 = { class: "wrap_button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "content_box",
        style: _normalizeStyle(_ctx.getDisplay() ? 'margin-top: 30px' : '')
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_input, {
                class: "form_item_name",
                value: _ctx.formData.username,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.username) = $event)),
                placeholder: "请输入手机号",
                onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.isShowform)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_input_password, {
                      class: "form_item_name",
                      style: {"height":"0.8rem"},
                      value: _ctx.formData.password,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event)),
                      placeholder: "请输入密码",
                      onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                    }, null, 8, ["value"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_input, {
                      class: "form_bottom_valid",
                      style: {"height":"0.8rem"},
                      placeholder: "请输入验证码",
                      value: _ctx.formData.code,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.code) = $event)),
                      onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("button", {
                      class: "wrap_form_button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getCode()))
                    }, "获取验证码", 512), [
                      [_vShow, _ctx.isShowcode]
                    ]),
                    _withDirectives(_createElementVNode("span", { class: "wrap_form_vaild" }, " 获取验证码(" + _toDisplayString(_ctx.count) + ") ", 513), [
                      [_vShow, !_ctx.isShowcode]
                    ])
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_router_link, { to: "/lostpass" }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/register" }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handlSubmit()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("登录")
            ]),
            _: 1
          }),
          (_ctx.isShowform)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowform = !_ctx.isShowform))
              }, "验证码登录"))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowform = !_ctx.isShowform))
              }, "密码登录"))
        ])
      ], 4)
    ])
  ]))
}